﻿$.fn.dxCtrlSelectBoxAdressePostale = function custom_dxCtrlSelectBoxAdressePostale(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlselectboxadressepostal dx-ctrl")
        this.createInstance(new cdxCtrlSelectBoxAdressePostale(this, option));
    }
    return this;
}


window.cdxCtrlSelectBoxAdressePostale = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (name == "value") {
            if (typeof value == 'undefined') {
                return option[name];
            }
            else {
                option[name] = value;
                mConstruit()
            }
        } else {
            if (typeof value == 'undefined') {
                return dx.option(name);
            }
            else {
                dx.option(name, value);
            }
        }

    }

    var dx = null
    var $DivJaugeSaisie = null
    var reqAjax = null
    var ouvertureDropDownManuel = false
    function mConstruit() {
        container.empty();
        container.css("position", "relative")

        $DivJaugeSaisie = $("<div style='position:absolute;z-index:10;display:none;bottom:0;width:100%;height:2px;background-color:" + theme.backgroundcolorAccent + ";'><div style='height:100%;width:100%;background-image: url(" + imgJaugeSaisie + ");opacity:1;'></div></div>").appendTo(container)

        var timeOutRempliDs = null
        var hasValueChanged = false
        dx = $("<div/>").appendTo(container).dxAutocomplete({
            labelMode: option.labelMode,
            label: option.label,
            dataSource: [],
            value: option.value,
            disabled: option.disabled,
            maxLength: 300,
            placeholder: ((typeof option.placeholder == 'undefined') ? "..." : option.placeholder),
            dropDownOptions: {
                minWidth: 300,
                container: container
            },
            onOpened: function (e) {
                if (!ouvertureDropDownManuel) {
                    currentTextSearch = ""
                    dx.option("onKeyUp")(e)
                }
            },
            openOnFieldClick: false,
            showDropDownButton: true,
            onKeyUp: function (e) {
                if (currentTextSearch != e.component.option("text")) {

                    currentTextSearch = e.component.option("text")
                    e.component.option({
                        "dataSource": []
                    })
                    e.component.close()
                    window.clearTimeout(timeOutRempliDs)
                    if (currentTextSearch != null && currentTextSearch.length > 0) {
                        timeOutRempliDs = window.setTimeout(function () { mRempliDataSource(e.component.option("text")) }, 500);
                    }
                }
                hasValueChanged = true
            },
            onItemClick: function (e) {
                var itemData = e.itemData
                if (typeof itemData == "undefined") {
                    const ds = e.component.getDataSource().items();
                    itemData = ds[e.itemIndex]
                }
                e.component.option({
                    "dataSource": [],
                })
                if (typeof itemData != 'undefined') {
                    dx.option("value", itemData.adr.trim())
                    option.onSelectItem({ value: itemData });
                }

                dx.blur()
                disableChange = true
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                var $Table = $("<table/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px;padding-right:5px;' rowspan='2'><i class='fas fa-map-marked' style='color:" + theme.backgroundcolorAccent + "'/></td>").appendTo($Tr)
                var $Td = $("<td style='width:100%'>" + itemData.resume + "</td>").appendTo($Tr)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;font-size:80%;Font-style:italic;'></td>").appendTo($Tr)
                if (itemData.distance_km) {
                    $Td.text(itemData.distance_km + " km")
                }
                $Table.attr("title", itemData.resume)
            },
            onValueChanged: function (e) {
                hasValueChanged = true
                //option.onValueChanged(e.component.option("value"))
                //mConstruit()
            },
            onFocusIn: option.onFocusIn,
            onFocusOut: function (e) {
                console.log("ONFOCUSOUT")
                window.clearTimeout(timeOutRempliDs)
                if (reqAjax) {
                    reqAjax.abort()
                    reqAjax = null
                }
                e.component.close()
                $DivJaugeSaisie.hide()
                if (hasValueChanged && typeof option.onValueChanged != 'undefined') option.onValueChanged(dx.option("value"))
                hasValueChanged = false
                if (typeof option.onFocusOut != 'undefined') option.onFocusOut(e)
            },
            onContentReady: function (e) {
                if (!option.isExterne) e.component.element().find("input").attr('autocomplete', "fgakeautocomplet");
                e.component.element().find("input").attr("name", "kjkjkljlkjlmklmlk")
                if (typeof option.onContentReady != 'undefined') option.onContentReady(e)
                //focus suivant sur enter
                container.find('.dx-texteditor-input').off('keydown.next')
                container.find('.dx-texteditor-input').on('keydown.next', function (e) {
                    const key = e.key || e.keyCode || e.which;
                    if (key === 'Enter' || key === 13) {
                        e.preventDefault();
                        let inputs = $('.dx-texteditor-input:visible');
                        let index = inputs.index(this);
                        if (index > -1 && index + 1 < inputs.length) {
                            inputs.eq(index + 1).focus();
                        }
                    }
                });
            }
        }).dxAutocomplete("instance")

    }


    var dsResultAdresse = null
    var currentTextSearch = null;
    var reqAjax = null
    var disableFocusIn = false
    function mRempliDataSource(TextRecherche) {
        $DivJaugeSaisie.show()
        currentTextSearch = TextRecherche;
        dx.close()
        if (reqAjax) {
            reqAjax.abort()
            reqAjax = null
        }
        reqAjax = (new cGoogleMapsApi(option.bddCtrl)).mGetLstAdressFromString(currentTextSearch, function (lstAdresse) {
            reqAjax = null
            dsResultAdresse = lstAdresse
            if (dsResultAdresse.length > 0) {
                dx.close()
                console.log(dsResultAdresse)
                disableFocusIn = true
                dx.option("dataSource", dsResultAdresse)
                disableFocusIn = false
                ouvertureDropDownManuel = true
                dx.open()
                window.setTimeout(function () { ouvertureDropDownManuel = false }, 100);
            } else {
                console.log("rien")
                dx.option({
                    dataSource: []
                })
                dx.close()
            }
            $DivJaugeSaisie.hide()
        })
    }

    this.mReload = function () {
        mConstruit()
    }

    this.element = function () { return container; }
    this.focus = function () { dx.focus() }

    mConstruit();
}